import { render, staticRenderFns } from "./IntentCreatePage.vue?vue&type=template&id=db929432"
import script from "./IntentCreatePage.vue?vue&type=script&lang=js"
export * from "./IntentCreatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports